// src/com/file_of_report/TransPlanReportDef.js
// 운송요청(레포트) 정의

import { AppWord, TableColumnType } from "../../value/AppConst";

export const TransPlanReportMeta = {
    instructions: {
        // title: '운송요청 Report(Exp.)',
        headerRowSpan: 1,
        headerRows: [],
        headerBackgroundColor: 'FFFFFF88',
    },
}

export const TransPlanReportColumns = [
    { id: 'planId', width: 120, label: '의뢰번호', option:{type:TableColumnType.TEXT} },
    { id: 'storeName', width: 104, label: '도착지', option:{type:TableColumnType.TEXT} },
    { id: 'hocha', width: 40, label: '호차', noTotal: true, option:{align: AppWord.CENTER, type:TableColumnType.INTEGER} },
    { id: 'dockno', width: 80, label: 'Dock NO', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'transType', width: 88, label: '배차구분', option:{type:TableColumnType.TEXT} },
    { id: 'vehTypeId', width: 48, label: '차종', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종명', option:{type:TableColumnType.TEXT} },
    { id: 'comName', width: 152, label: '운송사', option:{type:TableColumnType.TEXT} },
    { id: 'shprReqTime', width: 152, label: '접안요청일시', option:{type:TableColumnType.DATETIME} },
    { id: 'dptrReqTime', width: 152, label: '출발요청시간', option:{type:TableColumnType.DATETIME} },
    { id: 'arrReqTime', width: 152, label: '점포도착예정시간', option:{type:TableColumnType.DATETIME} },
    { id: 'addCharge', width: 104, label: '추가운임비', option:{type:TableColumnType.INTEGER} },
    { id: 'note', width: 208, label: '비고', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 152, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 104, label: '운전기사', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
];
